import React from "react"
import PopUp from "../components/typeform"
import { ImageHand } from "./gatsby-image/hand-images"

const FinalCTA = ({buttonText, description}) => {
  return (
    <div className="section-cnt final-cta">
      <div className="color-bg" style={{ background: " #6ebcd9" }} />
      <div className="flex-cnt margin">
        <div className="contents">
          <h2>Start the process</h2>
          <p className="description">
            {description}
          </p>
          <PopUp>
            <button>{buttonText}</button>
          </PopUp>
          <div className="hand">
            <ImageHand src="hold" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default FinalCTA
